import { render, staticRenderFns } from "./select-primary.vue?vue&type=template&id=b017f2d6&scoped=true&"
import script from "./select-primary.vue?vue&type=script&lang=js&"
export * from "./select-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b017f2d6",
  null
  
)

export default component.exports